<template>
  <div class="container py-3">
    <h3 class="text-center">Component</h3>
    <div class="d-flex justify-content-center">
      <vp-treeselect
        v-model="treeModel"
        :label="label"
        :isMultiple="isMultiple"
        :errMsg="errMsg"
        :showPlaceholderIcon="showPlaceholderIcon"
        :options="options"
        :disabled="!options.length || disabled"
        :isLoading="loading || isLoading"
        :width="width"
        :noResultsText="noResultsText"
        :dropDownStyle="dropDownStyle"
        :defaultExpandLevel="defaultExpandLevel"
        :disableBranchNodes="disableBranchNodes"
        :valueFormat="valueFormat"
        :backspaceRemoves="backspaceRemoves"
      />
    </div>

    <div class="d-flex justify-content-center">
      <button
        class="vp-bg-blue-1 vp-ml-20 vp-mt-15"
        :disabled="options.length > 0"
        @click="fetchUsersType"
      >
        Fetch users type
      </button>

      <button
        class="vp-bg-blue-1 vp-ml-20 vp-mt-15"
        :disabled="!options.length"
        @click="clearUsersType"
      >
        Clear users type
      </button>
    </div>

    <div class="text-center mt-2 vp-color-black-1 vp-mb-20">
      v-model : {{ treeModel }}
    </div>

    <div class="col-container">
      <div class="vp-col vp-border-black-1-2 rounded">
        <h5 class="vp-font-weight-700">#General props</h5>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">width ({{ width }}px)</label>
          <div class="col-4">
            <b-form-input
              id="range-1"
              v-model="width"
              type="range"
              min="300"
              max="700"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">label</label>
          <div class="col-sm-8">
            <input
              class="form-control vp-width-200"
              v-model="label"
              placeholder="Title.."
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">noResultsText</label>
          <div class="col-sm-8">
            <input
              class="form-control vp-width-200"
              v-model="noResultsText"
              placeholder="No results found .."
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">dropDownStyle</label>
          <div class="col-sm-8">
            <select v-model="dropDownStyle" class="custom-select vp-width-200">
              <option value="absolute">absolute</option>
              <option value="relative">relative</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">defaultExpandLevel</label>
          <div class="col-sm-8">
            <input
              class="form-control vp-width-70"
              type="number"
              v-model="defaultExpandLevel"
              :initialValue="defaultExpandLevel"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">isMultiple</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="isMultiple" :initialValue="isMultiple" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">backspaceRemoves</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="backspaceRemoves" :initialValue="backspaceRemoves" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">valueFormat</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <select v-model="valueFormat" class="custom-select vp-width-200">
              <option value="object">object</option>
              <option value="id">id</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">flat</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="flat" :initialValue="flat" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">showPlaceholderIcon</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch
              v-model="showPlaceholderIcon"
              :initialValue="showPlaceholderIcon"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">disabled</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="disabled" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">disableBranchNodes</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="disableBranchNodes" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">isLoading</label>
          <div class="col-sm-8 vp-mt-minus-8">
            <vp-switch v-model="isLoading" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-form-label">errMsg</label>
          <div class="col-sm-8">
            <input
              class="form-control vp-width-200"
              v-model="errMsg"
              placeholder="Invalid value.."
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userServices from "@/services/userType";

export default {
  data() {
    return {
      treeModel: null,
      options: [],
      // options: [ {
      //     id: 'a',
      //     label: 'a',
      //     children: [ {
      //       id: 'aa',
      //       label: 'aa',
      //     }, {
      //       id: 'ab',
      //       label: 'ab',
      //     } ],
      //   }, {
      //     id: 'b',
      //     label: 'b',
      //   }, {
      //     id: 'c',
      //     label: 'c',
      //   } ],
      width: "461",
      loading: false,
      label: "Label",
      noResultsText: "",
      errMsg: "",
      showPlaceholderIcon: true,
      disabled: false,
      isLoading: false,
      defaultExpandLevel: "0",
      disableBranchNodes: false,
      isMultiple: false,
      dropDownStyle: "absolute",
      flat: false,
      backspaceRemoves:false,
      valueFormat: "id",
      valueFormatOptions: ["id", "object"],
    };
  },
  methods: {
    async fetchUsersType() {
      this.loading = true;
      const userTypes = await userServices.getAllUsersTypes();
      this.options = userTypes.data;
      // this.treeModel = ["a2866040-3378-4bcf-8bf9-a223054954f5"]
      this.loading = false;
    },
    clearUsersType() {
      this.options = [];
      // if (Array.isArray(this.treeModel)) this.treeModel.splice(0);
      this.treeModel = null;
    },
  },
};
</script>

<style scoped>
button {
  height: fit-content;
  width: fit-content;
  border: none;
  color: #ffff;
  border-radius: 10px;
  padding: 4px;
}
button:disabled {
  background-color: #103f5e50;
}

:disabled {
  background: #dcdad1 !important;
}
label,
h1,
h2,
h3,
h4,
h5 {
  color: black;
}
h5 {
  text-decoration: underline;
}
.col-container {
  display: table;
  width: 110%;
  border-spacing: 3px;
  margin-inline-start: -25px;
}
.vp-col {
  display: table-cell;
  padding-inline-end: 5px;
}
</style>
